import { useQuery } from "@tanstack/react-query";
import { acceptInvite, fetchInvite, fetchMembers } from "../api/index.js";
import { queryKeys } from "../query-keys.js";

/** The people in this workspace and, for an owner, the invites still open. */
export function useMembers(workspaceId: string, enabled = true) {
  return useQuery({
    queryKey: queryKeys.members(workspaceId),
    queryFn: () => fetchMembers(workspaceId),
    enabled,
  });
}

/** What an invite link opens. Null is a link that was never issued. */
export function useInvite(token: string) {
  return useQuery({
    queryKey: queryKeys.invite(token),
    queryFn: () => fetchInvite(token),
    // A dead link is an answer, not a blip worth retrying.
    retry: false,
  });
}

/**
 * Joins the invite for someone already signed in. A query, not an effect
 * firing a mutation: the cache sends it once per link and person however often
 * the screen renders, and the server answers a repeat `joined` anyway.
 */
export function useInviteAcceptance(token: string, userId: string | null) {
  return useQuery({
    queryKey: queryKeys.inviteAcceptance(token, userId ?? ""),
    queryFn: () => acceptInvite(token),
    enabled: userId !== null,
    retry: false,
    staleTime: Infinity,
  });
}
